import React from "react";
import { Link } from "react-router-dom";
import { DisclosureBanner } from "./DisclosureBanner";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            style={{ background: "#1C2833", color: "#FAF9F6" }}
            className="mt-0"
        >
            <DisclosureBanner variant="footer" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="font-serif-display text-2xl sm:text-3xl tracking-tight">
                            Better Rest{" "}
                            <span className="italic text-[#A9C2D6]">
                                Report
                            </span>
                        </div>
                        <p className="mt-4 text-sm leading-relaxed font-light opacity-80 max-w-md">
                            An independent editorial review focused on the
                            small things that shape a great night — fabrics,
                            contours, and the quiet rituals of rest.
                        </p>
                        <p className="mt-6 text-[11px] tracking-[0.22em] uppercase opacity-60">
                            SleepComfortReport.com
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="text-[11px] tracking-[0.22em] uppercase opacity-60 mb-4">
                            Editorial
                        </p>
                        <ul className="space-y-3 text-sm font-light">
                            <li>
                                <Link
                                    to="/"
                                    data-testid="footer-link-home"
                                    className="hover:opacity-80"
                                >
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    data-testid="footer-link-contact"
                                    className="hover:opacity-80"
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="text-[11px] tracking-[0.22em] uppercase opacity-60 mb-4">
                            Legal
                        </p>
                        <ul className="space-y-3 text-sm font-light">
                            <li>
                                <Link
                                    to="/privacy"
                                    data-testid="footer-link-privacy"
                                    className="hover:opacity-80"
                                >
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/terms"
                                    data-testid="footer-link-terms"
                                    className="hover:opacity-80"
                                >
                                    Terms of Use
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/disclosure"
                                    data-testid="footer-link-disclosure"
                                    className="hover:opacity-80"
                                >
                                    Affiliate Disclosure
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-[11px] tracking-[0.18em] uppercase opacity-60">
                    <span>
                        © {new Date().getFullYear()} Better Rest Report. All
                        rights reserved.
                    </span>
                    <span className="max-w-2xl leading-relaxed normal-case tracking-normal text-xs opacity-90">
                        Disclaimer: This site is for informational purposes
                        only. Content is editorial and does not constitute
                        professional health advice. Always consult a
                        qualified professional for any health concerns.
                    </span>
                </div>
            </div>
        </footer>
    );
};
